module.exports = __webpack_public_path__ + "assets/img/bottom-bg.29bb40b5.png";